import * as M from '@mantine/core';
import { IconChevronLeft } from '@tabler/icons-react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { useGetAiAgentModelSettingHistory } from '../../../../../../shared/apis/ai-agent/model/reactQueries';

import * as C from '../../../../../ui/common/CommonStyles';

import { buildSearchString } from '../../utils/buildSearchString';
import useAiAgentModelHistoryFilters from './hooks/useAiAgentModelHistoryFilters';
import AiAgentModelFilterSection from './ui/filterSection';
import ModelHistoryTable from './ui/modelHistoryTable';

export default function AiAgentModelHistory() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const companyName = searchParams.get('companyName') || '';
  const modelName = searchParams.get('modelName') || '-';
  const { companyId, modelId } = useParams<{ companyId: string; modelId: string }>();
  const { filterForm, queryParams, updateFilterForm, applyFilters, resetFilters, handlePageChange } =
    useAiAgentModelHistoryFilters(Number(companyId), Number(modelId));

  const { data, isLoading, isError } = useGetAiAgentModelSettingHistory(queryParams);

  return (
    <M.Box>
      <C.TitleBox>
        <div className="title">기계모델 설정 이력</div>
      </C.TitleBox>
      <C.ListBox>
        <M.Stack gap="lg">
          <M.Flex
            gap="md"
            align="center"
            justify="space-between"
            style={(theme) => ({
              border: `1px solid ${theme.colors.gray[3]}`,
              backgroundColor: theme.colors.gray[0],
              borderRadius: theme.radius.sm,
              padding: theme.spacing.sm,
            })}
          >
            <M.Flex gap="md">
              <M.Box>
                <M.Text size="xs" c="gray.6">
                  회사명
                </M.Text>
                <M.Text fw={500}>{companyName}</M.Text>
              </M.Box>
              <M.Box>
                <M.Text size="xs" c="gray.6">
                  기계모델명(모델코드)
                </M.Text>
                <M.Text fw={500}>{modelName}</M.Text>
              </M.Box>
            </M.Flex>
            <M.Button
              variant="default"
              size="xs"
              leftSection={<IconChevronLeft size={14} />}
              onClick={() =>
                navigate(
                  `/admin/management/aiagent/company/${companyId}/model${buildSearchString({
                    companyName: companyName,
                  })}`,
                  { replace: true },
                )
              }
            >
              목록으로
            </M.Button>
          </M.Flex>
          <AiAgentModelFilterSection
            filterForm={filterForm}
            onChangeFilterForm={updateFilterForm}
            onSearch={applyFilters}
            onReset={resetFilters}
          />
          <ModelHistoryTable
            data={data}
            page={queryParams.page ?? 1}
            size={queryParams.size ?? 10}
            isLoading={isLoading}
            isError={isError}
            onPageChange={handlePageChange}
          />
        </M.Stack>
      </C.ListBox>
    </M.Box>
  );
}
